import { render, staticRenderFns } from "./SidebarLayoutTwo.vue?vue&type=template&id=58161fcb&"
import script from "./SidebarLayoutTwo.vue?vue&type=script&lang=js&"
export * from "./SidebarLayoutTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports